module.exports = __webpack_public_path__ + "img/安卓.b39d7be5.png";